import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';

import './Style';

class DescriptionContainer extends Component {
    render () {

        const { description } = this.props;

        if (!description.length) {
            return null;
        }

        return (
            <div id="description" className="description-component">
                <h2 className="section-header">Description</h2>
                <p className="description-component-content">
                    {ReactHtmlParser(description)}
                </p>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        description: state.property.info.description
    }
}

export default connect(mapStateToProps)(DescriptionContainer)
